module.exports = __webpack_public_path__ + "img/photoshop.b8c25091.png";